import { IEnvironment } from './environment.model';

export const environment: IEnvironment = {
  production: false,
  environment: 'local',
  gioco_user_id: 53095,
  site: 'http://localhost:4300',
  api: {
    host: 'http://localhost:4300',
    site: 'http://localhost:4300',
  },
  solarium:{
    host: 'http://localhost:3000'
  },
  firebase: {

   config: {
      apiKey: 'AIzaSyBAmU00D66S2rOqheOSz2wkDICxaiJMGVU',
      authDomain: 'gioco-231016.firebaseapp.com',
      databaseURL: 'https://gioco-231016.firebaseio.com',
      projectId: 'gioco-231016',
      storageBucket: 'gioco-231016.appspot.com',
      messagingSenderId: '344348449281',
      appId: '1:344348449281:web:9a80db656f2fcb56eb7e00'
    },
    cloud_message_key: 'BHych1OLPiKw66KzmHrsLB--T-QhZpzkuZxP6aBMlq1yF7ar0ne25AbefuZu6tg6Vno_ePKUPzEPpwtMwtdWJKs',
    publicImagePath: 'https://firebasestorage.googleapis.com/v0/b/gioco-231016.appspot.com/o/'

    /*
    config: {
      apiKey: 'AIzaSyCOZ7-smJLhBtIYp6pu3CDip64TvjPj7ZQ',
      authDomain: 'gioco-staging.firebaseapp.com',
      databaseURL: 'https://gioco-staging.firebaseio.com',
      projectId: 'gioco-staging',
      storageBucket: 'gioco-staging.appspot.com',
      messagingSenderId: '1012689637875',
      appId: '1:1012689637875:web:b8c2eff944ef3f95',
    },
    cloud_message_key: 'BJhDfCu7dRSxugm6ow-jcfpDeeuouFyoy6yThysxrObivreeJlmTI3Sp5eKhRKcOts8LC29u-7rxA_YnNiXvFco',
    publicImagePath: 'https://firebasestorage.googleapis.com/v0/b/gioco-staging.appspot.com/o/'
    */
  },
  cache: [
    { type: 'api', endpoint: 'account_types', validity_min: 240 },
    { type: 'api', endpoint: 'sports', validity_min: 120 }
  ]
};
